import { render, staticRenderFns } from "./AiGenerateButtonNotAgreement.vue?vue&type=template&id=31163bba&"
import script from "./AiGenerateButtonNotAgreement.vue?vue&type=script&lang=ts&"
export * from "./AiGenerateButtonNotAgreement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports